export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.client && to.fullPath !== from.fullPath) {
    const store = useStore()
    const { rev } = storeToRefs(store)
    if (!rev.value || Date.now() - rev.value.date > 3600000) {
      const revData = await $fetch('/server/rev', {
        method: 'POST'
      })
      if (rev.value && revData !== rev.value.version) {
        window.location.href = to.fullPath
        return
      }
      rev.value = { version: revData, date: Date.now() }
    }
  }
})
